import { graphql } from "relay-runtime"

export const deDeleteProgressNotesMutation = graphql`
  mutation deDeleteProgressNotesMutation($input: De_deleteProgressNotesInput!, $connections: [ID!]!) {
    deleteProgressNotes: de_deleteProgressNotes(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      progressNote: de_ProgressNote {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
